import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import {
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
  TableBody
} from '@material-ui/core'
import { priceOnlyFormat } from '../../utils/priceFormat'


@inject('ActivityStore')
@observer
class ReferralActivity extends Component {

  componentDidMount() {
    this.props.ActivityStore.fetchReferral()
  }

  handlePageChange = (e, page) => {
    this.props.ActivityStore.referralPageOnChange(page)
  }

  handleChangeRowsPerPage = e => {
    this.props.ActivityStore.referralPageSizeOnChange(e.target.value)
  }
  render() {

    const { referralQuery, referralPage, referral } = this.props.ActivityStore
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    Customer
                  </TableCell>
                  <TableCell>
                    Referred friend
                  </TableCell>
                  <TableCell>
                    Order id
                  </TableCell>
                  <TableCell>
                    Order status
                  </TableCell>
                  <TableCell align='right'>
                    Order total($)
                  </TableCell>
                  <TableCell align='right'>
                    Date
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {referral.map(item => (
                <TableRow key={item.id}>
                  <TableCell>
                    {item.customer_first_name} {item.customer_last_name}
                  </TableCell>
                  <TableCell>
                    {item.friend_first_name} {item.friend_last_name}
                  </TableCell>
                  <TableCell>
                    {item.order_shopify_id}
                  </TableCell>
                  <TableCell>
                    {item.order_status}
                  </TableCell>
                  <TableCell align='right'>
                    {/* {item.order_dollar_price} */}
                    {priceOnlyFormat(item.order_dollar_price)}
                  </TableCell>
                  <TableCell align='right'>
                    {new Date(item.created).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
              </TableBody>
            </Table>
            
            <TablePagination 
              rowsPerPageOptions={[15, 30, 100]}
              component='div'
              count={referralQuery.count}
              rowsPerPage={referralQuery.limit}
              page={referralPage}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
      </Grid>
    )
  }
}
export default ReferralActivity